export const URL = process.env.URL;
export const API_URL = process.env.API_URL;
export const SENTRY_DSN = process.env.SENTRY_DSN;
export const SENTRY_AUTH_TOKEN = process.env.SENTRY_AUTH_TOKEN;
export const DEFAULT_BRANDING_URL = 'https://funnelleasing.com/';
export const GOOGLE_ANALYTICS_TRACKING_ID = process.env.GOOGLE_ANALYTICS_TRACKING_ID;
